import { GetStaticPaths, GetStaticPathsResult, GetStaticProps } from "next";
import { MissUnderstandingParlorDetailContiner } from "@/containers/MissParlorDetailContainer";

import parlors from "@/constants/parlors_detail.json";
import { skipDevBuildInGetStaticPaths } from "@/utils/skipDevBuildInGetStaticPaths";
import { ParlorDetailProps } from "@/types/parlor";

export const getStaticPaths: GetStaticPaths = async () => {
  const skipBuildResult =
    skipDevBuildInGetStaticPaths() as GetStaticPathsResult;

  if (skipBuildResult) {
    return skipBuildResult;
  }

  const paths = parlors.map((parlor) => ({
    params: {
      id: parlor.id.toString(),
    },
  }));

  return {
    paths,
    fallback: false,
  };
};

export const getStaticProps: GetStaticProps = async ({ params }) => {
  const parlor = parlors.find(
    (parlor) => parlor.id === parseInt(params?.id as string)
  );

  const description = `유가족의 슬픔을 함께하는 마음으로 ${
    parlor?.address || ""
  } ${
    parlor?.companyname || ""
  } 장례식장 안내, 비용 견적, 장례 절차, 오시는 길, 화환 보내기, 빈소 문의, 비용 견적`;
  const keywords = `${parlor?.companyname}`;
  const title = parlor?.companyname || "";

  return {
    props: {
      defaultParlor: parlor,
      pageDescription: description,
      pageKeywords: keywords,
      pageOgTitle: title,
      pageOgDescription: description,
      pageOgImage:
        parlor?.images[0]?.url ||
        `${process.env.NEXT_PUBLIC_CDN_URL}/ogimage.png`,
      // closestParlorsByService,
      // discountDescription,
    },
  };
};

interface ParlorFamilyMainPageProps {
  defaultParlor: ParlorDetailProps;
}

const ParlorFamilyMainPage = ({ defaultParlor }: ParlorFamilyMainPageProps) => {
  return (
    <MissUnderstandingParlorDetailContiner defaultParlor={defaultParlor} />
  );
};

export default ParlorFamilyMainPage;
